import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive'
import plugin from './plugins'
import { preloadDictionaries } from '@/store/dictionary-helper'

import '@/plugins/element'

// 主样式文件导入
import '@/styles/index.scss'
import '@/assets/iconfont/iconfont.scss'

import '@/icons' // icon
import '@/permission'

// 引入全局组件
import EmptyContent from './components/EmptyContent/index'

// 全局过滤器
import * as filters from './filters'
// 注册全局过滤器
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

Vue.component('EmptyContent', EmptyContent)

Vue.use(directive)
Vue.use(plugin)

Vue.config.productionTip = false

// 预加载字典
preloadDictionaries('dictionary', ['messagesTagsDict'])

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
